import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/security')({
  head: () => ({
    meta: [{ title: 'Security | Tekst' }],
  }),
});
